import axios from 'axios'
import React, { useEffect, useRef, useState } from 'react'
import styles from './OemPage.module.scss'
import Button from '@material-ui/core/Button';
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import InputBase from '@material-ui/core/InputBase';
import ChevronRightIcon from '@material-ui/icons/ChevronRight';
import ListItemSecondaryAction from '@material-ui/core/ListItemSecondaryAction';
import CircularProgress from '@material-ui/core/CircularProgress'
import CheckCircleIcon from '@material-ui/icons/CheckCircle';
import CancelIcon from '@material-ui/icons/Cancel';
import { QRCodeSVG } from 'qrcode.react';

import ListItemText from '@material-ui/core/ListItemText';

// important for correct compilation
/* global ApplePaySession */

export const OemPage = () => {
    // парамеры из URL
    const buttonRef = useRef(null);
    const urlSearchParams = new URLSearchParams(window.location.search);
    // TODO HARDCODE
    const merchantId = urlSearchParams.get('merchant_identifier');
    const amount = urlSearchParams.get('amount');
    const currency = urlSearchParams.get('currency');

    const [isApplePayAvailable, setIsApplePayAvailable] = useState(null);
    const [isApplePaySDKLoaded, setIsApplePaySDKLoaded] = useState(false);

    const validateMerchantUrl = async (validationURL) => {
      try {
        const url = '/apple-pay/validate-merchant' + window.location.search;        

        const { data } = await axios.post(url, { url: validationURL });
        return data;
      } catch (error) {
        return Promise.reject(error);
      }
    };

    function onApplePayButtonClicked() {
        console.log('onApplePayButtonClicked');
        
        const request = {
          countryCode: (navigator.language && navigator.language.includes('-')
            ? navigator.language.split('-')[1]
            : 'UK'
          ).toUpperCase(),
          currencyCode: currency,
          merchantCapabilities: ['supports3DS'],
          supportedNetworks: ['visa', 'masterCard'],
          total: { label: urlSearchParams.get('order'), amount }
        };
        console.log('request', request);

        const session = new ApplePaySession(3, request);
        
        session.onvalidatemerchant = async (event) => {
          try {
            console.log('onvalidatemerchant', event);

            const response = await validateMerchantUrl(event.validationURL);
            console.log('merchantSession', response['merchant_session']);

            session.completeMerchantValidation(response['merchant_session']);            
          } catch (error) {
            console.error('Merchant validation failed', error);
            session.abort();
          }
        };

        session.onpaymentauthorized = async (event) => {
                  
            const isSuccess = Boolean(event.payment && event.payment.token);

            const host = '/apple-pay/authorize';
            const params = { 
                "oem_token": event.payment.token, 
                ...Object.fromEntries(urlSearchParams.entries()) 
            };

            const { data } = await axios.post(host, params);

            console.log('response', data);

            // TODO: check response
            session.completePayment(
                isSuccess
                ? ApplePaySession.STATUS_SUCCESS
                : ApplePaySession.STATUS_FAILURE
            );

            window.location.href = data['finish_url'];
        };

        session.begin();
    }    

    useEffect(() => {

        const script = document.createElement('script');
        script.src = 'https://applepay.cdn-apple.com/jsapi/1.latest/apple-pay-sdk.js';
        script.crossOrigin = true;

        script.onload = () => setIsApplePaySDKLoaded(true);
        document.body.appendChild(script);

        return () => {
            document.body.removeChild(script);
        };
    }, []);


    // Check Apple Pay availability, but only after the SDK script has loaded
    useEffect(() => {
        if (!isApplePaySDKLoaded) return; // wait until SDK is ready
        const verifyApplePay = async () => {
            if (!window.ApplePaySession) {
                console.log('ApplePaySession not supported (reason 1)');
                return setIsApplePayAvailable(false);
            }

            try {                
                const result = window.ApplePaySession.canMakePaymentsWithActiveCard(merchantId);

                // If API returns boolean instead of promise
                if (typeof result === 'boolean') {
                    setIsApplePayAvailable(result);
                    return console.log(`ApplePaySession ${result ? '' : 'not '}supported (reason 2)`);
                }

                const canPay = await result;
                setIsApplePayAvailable(canPay);
                console.log(`ApplePaySession ${canPay ? '' : 'not '}supported (reason 3)`);
            } catch (err) {
                console.log('ApplePaySession check failed (reason 4)', err);
                setIsApplePayAvailable(false);
            }
        };
        verifyApplePay();
        // setIsApplePayAvailable(true)
    }, [isApplePaySDKLoaded]);
       

    useEffect(() => {
        if (isApplePayAvailable && buttonRef.current) {
          buttonRef.current.addEventListener('click', onApplePayButtonClicked);
        }
        return () => {
          if (buttonRef.current) {
            buttonRef.current.removeEventListener('click', onApplePayButtonClicked);
          }
        };
      }, [isApplePayAvailable]);    
    //

    if (false) { 
    } else {
        return (
            <>
            <div className={styles.pageWrapper}>
                <div className={styles.centerWrapper}>
                    <h1>Apple Pay</h1>
                    <p>Pay securely.</p>

                    { (amount && currency) && (
                        <p>
                            {(() => {
                                const symbols = { USD: '$', EUR: '€', GBP: '£', JPY: '¥', CNY: '¥', CAD: '$', AUD: '$' };
                                const upperCurrency = currency.toUpperCase();
                                const symbol = symbols[upperCurrency];

                                return symbol ? (
                                    <>
                                        <span className={styles.currency}>{symbol}</span>{' '}
                                        <span className={styles.amount}>{amount}</span>
                                    </>
                                ) : (
                                    <>
                                        <span className={styles.amount}>{amount}</span>{' '}
                                        <span className={styles.currency}>{upperCurrency}</span>
                                    </>
                                );
                            })()}
                        </p>
                    )}


                    <style>
                        {`
                        apple-pay-button {
                            --apple-pay-button-width: 200px;
                            --apple-pay-button-height: 40px;
                            --apple-pay-button-border-radius: 8px;
                            --apple-pay-button-padding: 0px 0px;
                            --apple-pay-button-box-sizing: border-box;
                        }
                        `}
                    </style>
                    {isApplePayAvailable === null ? (
                        <div style={{ textAlign: 'center' }}>
                            <CircularProgress size={24} />
                        </div>
                    ) : isApplePayAvailable ? (
                        <apple-pay-button 
                            buttonstyle="black" 
                            type="plain" 
                            locale="en-US"
                            ref={buttonRef}
                        />
                    ) : (
                        <div style={{ 
                            color: '#FF3B30',
                            textAlign: 'center',
                            fontSize: '17px',
                            fontWeight: '400',
                            fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", sans-serif',
                            opacity: 0.8
                        }}>
                            <div style={{ display: 'flex', flexDirection: 'column', alignItems: 'center', gap: '16px' }}>
                                <QRCodeSVG
                                    value={window.location.href}
                                    size={Math.min(window.innerWidth * 0.4, 200)}
                                    level="H"
                                    includeMargin={false}
                                />
                                <div style={{ 
                                    color: '#000000',
                                    fontSize: '17px',
                                    fontWeight: '400',
                                    fontFamily: '-apple-system, BlinkMacSystemFont, "SF Pro Text", "Helvetica Neue", sans-serif'
                                }}>
                                    Apple Pay is not available on this device
                                    <br />
                                    Please scan QR code to open on iPhone, iPad or Mac
                                </div>
                            </div>
                        </div>
                    )}

                </div>
            </div>
            </>
        )
    }   
}